import React, { useState } from "react";
import { getAuth } from "firebase/auth";
import { getCloudFunctionUrl } from "../../config/firebaseFunctionUrl";

const PaymentButton = ({ amount, currency = "usd", priceId, credits }) => {
  const [isLoading, setIsLoading] = useState(false);

  const handleClick = async () => {
    try {
      if (!priceId) {
        throw new Error("Price ID is required");
      }

      const auth = getAuth();
      const user = auth.currentUser;
      if (!user) throw new Error("User must be logged in to purchase credits");
      const idToken = await user.getIdToken();

      setIsLoading(true);
      // Create a server-side Stripe Checkout session for credits
      const resp = await fetch(
        getCloudFunctionUrl('createCreditsCheckoutSession'),
        {
          method: "POST",
          headers: {
            "Content-Type": "application/json",
            Authorization: `Bearer ${idToken}`,
          },
          body: JSON.stringify({ priceId }),
        }
      );
      if (!resp.ok) {
        const err = await resp.json().catch(() => ({}));
        throw new Error(err.error || "Failed to start checkout session");
      }
      const data = await resp.json();
      if (!data?.url) throw new Error("Missing checkout URL from server");
      window.location.href = data.url;
    } catch (error) {
      console.error("Payment failed:", error);
      alert(error?.message || "Payment failed");
      setIsLoading(false);
    }
  };

  return (
    <>
      {/* Loading overlay while we create session and redirect */}
      {isLoading && (
        <div className="fixed inset-0 z-50 flex items-center justify-center bg-black/30">
          <div className="bg-white rounded-md shadow px-4 py-3 text-sm text-gray-700 flex items-center gap-3">
            <div className="h-5 w-5 border-2 border-gray-300 border-t-indigo-600 rounded-full animate-spin" />
            Redirecting to Stripe Checkout...
          </div>
        </div>
      )}

      <button
        onClick={handleClick}
        disabled={isLoading}
        className="w-full py-2 px-4 bg-indigo-600 hover:bg-indigo-700 disabled:opacity-50 text-white rounded-lg transition-colors"
      >
        {isLoading ? "Processing..." : `Get for $${amount}`}
      </button>
    </>
  );
};

export default PaymentButton;
